<template>
  <div
    id="app"
    class="has-background-light"
    :class="{'xmas': isXmasMonths }"
  >
  <template >
    <nav v-if="!isAuthLayout"
      class="navbar is-primary"
      role="navigation"
      aria-label="main navigation"
    >
      <div class="navbar-brand">
        <a
          class="navbar-item"
          href="/"
        >
          <span
            style="font-weight: bold; font-size: 20px"
          >JMAG Fulfilment</span>
        </a>
        <a
          role="button"
          class="navbar-burger burger"
          aria-label="menu"
          aria-expanded="false"
          data-target="navbarBasicExample"
        >
          <span aria-hidden="true" />
          <span aria-hidden="true" />
          <span aria-hidden="true" />
        </a>
      </div>

      <div
        id="navbarBasicExample"
        class="navbar-menu"
      >
        <div class="navbar-start">
          <template v-for="item in menu">
            <router-link v-if="hasFullAccess()"
             :key="item.name"
              class="navbar-item"
              :to="item.link"
              exact
            >
              {{ item.name }}
            </router-link>
          </template>
        </div>
      </div>
      <div v-if="isAuthenticated" class="navbar-item has-dropdown is-hoverable">
        <a class="navbar-link">{{ user.username }}</a>
        <div class="navbar-dropdown">
          <span class="navbar-item">{{ hasFullAccess() ? "Admin User" : "Read Only User" }}</span>
          <hr class="navbar-divider">
          <a class="navbar-item" @click="logout">Signout</a>
        </div>
      </div>
    </nav>
    <div :class="{ 'container has-background-white': !isAuthLayout }">
      <section :class="{'section': !isAuthLayout}">
        <router-view  :key="$route.fullPath"/>
      </section>
    </div>
  </template> 

  </div>
</template>
<script>
import { baseMixin } from "../mixins/baseMixin.js";
import { msal, Authenticated } from "./services/auth.js"; // NEW

export default {
  mixins: [baseMixin],
  data() {
    return {
      menu: [
        { name: "Dashboard", link: "/" },
        { name: "Help", link: "/Help", isCampaignSiteLayout: false },
        { name: "Fulfilment", link: "/fulfilment", isCampaignSiteLayout: false },
        { name: "Batch Jobs", link: "/batch-jobs", adminOnly: true, isCampaignSiteLayout: false },
        { name: "Batch Destination", link: "/batch-destination", adminOnly: true, isCampaignSiteLayout: false },
        { name: "Product Config", link: "/product-config", adminOnly: true, isCampaignSiteLayout: false },
        { name: "Contact Groups", link: "/contact-group", adminOnly: true, isCampaignSiteLayout: false },
        { name: "Quick Search", link: "/search-legacy-new", isCampaignSiteLayout: false },
        { name: "Campaign Sites", link: "/campaign-sites", adminOnly: true, isCampaignSiteLayout: true },
        { name: "Mini Sites", link: "/mini-sites", adminOnly: true, isCampaignSiteLayout: true },
      ]
    };
  },
  computed: {
    isXmasMonths() {
      return new Date().getMonth() >= 7 ;
    },
    isAuthenticated() {
      return Authenticated();
    },
    user() {
      return msal.getActiveAccount();
    },
    isAuthLayout() {
      return this.$route.meta.layout === "auth";
    },
    isCampaignSiteLayout() {
      return this.$route.meta.layout === "campaign-site";
    },
    currentId() {
      return this.$route.params?.id;
    },
  },
  created(){
    if(this.isXmasMonths && false){
      var sf = new Snowflakes({
          color: "#edf9fd",
          count: 100,
          minSize: 20,
          maxSize: 45
      });
    }
  },
  methods: {
    logout() {
      msal.logoutRedirect();
    },
  },
};
</script>